<div class="component-viewer">
    <div>
        <mat-card-title>Course Details</mat-card-title>
        <mat-card >
            <mat-card-content>
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                <div>Name</div>
                <div>{{course?.name}}</div><br/>
                <div>Short Name</div>
                <div>{{course?.shortName}}</div><br/>
                <div>Address</div>
                <div>{{course?.address}}</div><br/>
                <div>City</div>
                <div>{{course?.city}}</div><br/>
                <div>State</div>
                <div>{{course?.state}}</div><br/>
                <div>Zip Code</div>
                <div>{{course?.zipCode}}</div><br/>
                <div>Country</div>
                <div>{{course?.country}}</div><br/>
                <div>Is Private</div>
                <yes-no [value]="course.isPrivate"></yes-no>   
            </mat-card-content>
         </mat-card>
    </div>
</div>
